import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useKindeAuth } from '@kinde-oss/kinde-auth-react'

import { unsetContactId } from '@/app/slices/contactsSlice'
import { unsetCustomerId } from '@/app/slices/customerSlice'
import { selectIsGuestLoggedIn, unsetGuestUser } from '@/app/slices/guestUserSlice'
import { selectOrganisation } from '@/app/slices/organisationSlice'

/**
 * useSignIn - Starts Kinde sign-in for this store and brings the visitor back to the page they
 * were on (src/index.jsx reads `redirectTo` on the way back). Drops any guest session first, so
 * the signed-in customer does not inherit the guest's customer and contact ids.
 *
 * @returns {Function} signIn - Call it from a click handler.
 */
export function useSignIn() {
    const { i18n } = useTranslation()
    const dispatch = useDispatch()
    const { login } = useKindeAuth()
    const storeSettings = useSelector(selectOrganisation)
    const isGuestLoggedIn = useSelector(selectIsGuestLoggedIn)

    return () => {
        if (isGuestLoggedIn) {
            dispatch(unsetCustomerId())
            dispatch(unsetContactId())
            dispatch(unsetGuestUser())
        }
        login({
            lang: i18n.language,
            orgCode: storeSettings?.kindeOrganisationId,
            state: { redirectTo: window.location.href },
        })
    }
}
